"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var ReactDOM = require("react-dom");
var list_option_1 = require("./list-option");
var CustomPropTypes = require("../util/custom-prop-types");
var classnames_1 = require("../util/classnames");
var _1 = require("../util/_");
var data_helpers_1 = require("../util/data-helpers");
var widget_helpers_1 = require("../util/widget-helpers");
var interaction_1 = require("../util/interaction");
var vdl_prefix_1 = require("../util/vdl-prefix");
var matcher_1 = require("./matcher");
var localizers_1 = require("../util/localizers");
var optionId = function (id, idx) { return id + "__option__" + idx; };
var EMPTY_VALUE = {};
var isDisabledOrReadonly = function (item, props) { return interaction_1.isDisabledItem(item, props) || interaction_1.isReadOnlyItem(item, props); };
var List = /** @class */ (function (_super) {
    __extends(List, _super);
    function List() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.first = function () {
            return _this.next(EMPTY_VALUE);
        };
        _this.last = function () {
            var data = _this._data(), item = data[data.length - 1];
            return isDisabledOrReadonly(item, _this.props) ? _this.prev(item) : item;
        };
        _this.prev = function (item, word) {
            var data = _this._data(), nextIdx = data.indexOf(item), matches = matcher_1.matcher(word, item, _this.props.textField);
            if (nextIdx < 0 || nextIdx == null) {
                nextIdx = 0;
            }
            nextIdx--;
            while (nextIdx > -1 && (isDisabledOrReadonly(data[nextIdx], _this.props) || !matches(data[nextIdx]))) {
                nextIdx--;
            }
            return nextIdx >= 0 ? data[nextIdx] : item;
        };
        _this.next = function (item, word) {
            var data = _this._data(), nextIdx = data.indexOf(item) + 1, len = data.length, matches = matcher_1.matcher(word, item, _this.props.textField);
            while (nextIdx < len && (isDisabledOrReadonly(data[nextIdx], _this.props) || !matches(data[nextIdx]))) {
                nextIdx++;
            }
            return nextIdx < len ? data[nextIdx] : item;
        };
        _this._data = function () {
            return _this.props.data;
        };
        _this.move = function () {
            var list = ReactDOM.findDOMNode(_this), idx = _this._data().indexOf(_this.props.focused), selected = list.children[idx];
            if (!selected) {
                return;
            }
            widget_helpers_1.notify(_this.props.onMove, [selected, list, _this.props.focused]);
        };
        return _this;
    }
    List.prototype.componentDidMount = function () {
        this.move();
    };
    List.prototype.componentDidUpdate = function () {
        var _a = this.props, focused = _a.focused, onAriaActiveDescendant = _a.onAriaActiveDescendant;
        var data = this.props.data;
        var idx = data.indexOf(focused);
        var activeId = optionId(widget_helpers_1.instanceId(this), idx);
        if (onAriaActiveDescendant) {
            onAriaActiveDescendant(idx !== -1 ? activeId : undefined);
        }
        this.move();
    };
    List.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, role = _a.role, textField = _a.textField, valueField = _a.valueField, focused = _a.focused, selected = _a.selected, onSelect = _a.onSelect, disabled = _a.disabled, readOnly = _a.readOnly, disabledItems = _a.disabledItems, readOnlyItems = _a.readOnlyItems, ItemComponent = _a.itemComponent, ListOption = _a.optionComponent, id = widget_helpers_1.instanceId(this), items;
        var data = this.props.data;
        var messages = msgs(this.props.messages);
        items = !data.length ?
            (React.createElement(ListOption, { empty: true, role: "note" }, _1.result(messages.emptyList, this.props)))
            : data.map(function (item, idx) {
                var currentId = optionId(id, idx), isDisabled = interaction_1.isDisabledItem(item, _this.props), isReadOnly = interaction_1.isReadOnlyItem(item, _this.props);
                var handleSelect = function () {
                    if (onSelect) {
                        onSelect(item);
                    }
                };
                return (React.createElement(ListOption, { key: 'item_' + idx, id: currentId, dataItem: item, disabled: isDisabled, readOnly: isReadOnly, focused: focused === item, selected: interaction_1.contains(item, selected, valueField), onClick: isDisabled || isReadOnly ? undefined : handleSelect }, ItemComponent ?
                    (React.createElement(ItemComponent, { item: item, value: data_helpers_1.dataValue(item, valueField), text: data_helpers_1.dataText(item, textField), disabled: isDisabled, readOnly: isReadOnly }))
                    : data_helpers_1.dataText(item, textField)));
            });
        var listClasses = (_b = {},
            _b[vdl_prefix_1.vdlPrefix('list')] = true,
            _b[vdl_prefix_1.vdlPrefix('list--disabled')] = disabled === true,
            _b[vdl_prefix_1.vdlPrefix('list--readonly')] = readOnly === true,
            _b);
        var elementProps = _1.omit(this.props, Object.keys(List.propTypes));
        return (React.createElement("ul", __assign({}, elementProps, { id: id, tabIndex: -1, className: classnames_1.classNames(className, listClasses), role: role }), items));
        var _b;
    };
    List.propTypes = {
        data: PropTypes.array,
        onSelect: PropTypes.func,
        onMove: PropTypes.func,
        optionComponent: CustomPropTypes.elementType,
        itemComponent: CustomPropTypes.elementType,
        selected: PropTypes.oneOfType([PropTypes.any, PropTypes.array]),
        focused: PropTypes.any,
        valueField: CustomPropTypes.accessor,
        textField: CustomPropTypes.accessor,
        disabled: PropTypes.bool,
        disabledItems: PropTypes.array,
        readOnly: PropTypes.bool,
        readOnlyItems: PropTypes.array,
        messages: PropTypes.shape({
            emptyList: CustomPropTypes.message
        }),
        className: PropTypes.string,
        role: PropTypes.string,
        onAriaActiveDescendant: PropTypes.func
    };
    List.defaultProps = {
        optionComponent: list_option_1.ListOption,
        data: [],
        role: 'listbox'
    };
    return List;
}(React.Component));
exports.List = List;
function localizedMessage(messageKey, locale) {
    return localizers_1.message.formatMessage('adp-react-components/list/' + messageKey, undefined, locale);
}
function msgs(msgs, locale) {
    return Object.assign({
        emptyList: localizedMessage('EMPTY_LIST', locale)
    }, msgs);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/list/list.js
// module id = 530
// module chunks = 0 1 2 3 4 5 6